/**
 * Full-page "site under maintenance" view.
 * Shown when config siteUnderMaintenance === 'true' (driven by API env SITE_UNDER_MAINTENANCE).
 * Uses the same blue background and GoZig logo as login/error pages, plus the app spinner.
 */

import Background from '@/assets/background-image.jpg';
import GoZigLogo from '@/assets/logos/goZig-logo-light.svg';

interface MaintenancePageProps {
    /** Optional message from SITE_UNDER_MAINTENANCE_MESSAGE env */
    message?: string;
}

const DEFAULT_MESSAGE = 'We’re updating things to serve you better. Please check back soon.';

export const MaintenancePage = ({ message }: MaintenancePageProps) => {
    const displayMessage = (message?.trim() && message) || DEFAULT_MESSAGE;

    return (
        <div
            className="min-h-screen w-full flex flex-col items-center justify-center bg-secondary-dark p-6"
            style={{
                backgroundImage: Background ? `url(${Background})` : undefined,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }}
            data-testid="maintenance-page"
        >
            <div className="flex flex-1 items-center justify-center w-full p-6">
                <div className="bg-white rounded-lg shadow-xl border border-gray-200 p-8 w-full max-w-md">
                    <div>
                        <img
                            className="h-13 lg:h-16 w-auto"
                            src={GoZigLogo}
                            alt="GoZig"
                            aria-label="GoZig Logo"
                        />
                    </div>
                    <h1 className="text-2xl font-bold text-secondary-dark mb-2 mt-10">
                        Site under maintenance
                    </h1>
                    <p className="text-gray-700 mb-6">{displayMessage}</p>
                    <div className="flex flex-col items-center gap-4 pt-2">
                        <span
                            className="material-symbols-rounded !text-7xl animate-spin text-gray-light light:text-foreground dark:text-foreground"
                            aria-hidden
                        >
                            sync
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};
